import React from 'react';
import { Box, IconButton, Popover, TextField, Typography } from '@mui/material';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  XIcon,
} from 'react-share';
import { SparkButton } from 'sharedComponents/UI';
import { copyToClipboard } from 'utilities/index';
import CloseIcon from '@mui/icons-material/Close';

type CreateFavouriteListPopUpProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  shareLink?: string;
  resourceID?: string;
  resourceType?: 'spark' | 'memory';
  resourceAccessLinkToken?: string | null;
  privacyTypeId?: number | null;
};
function SparkShareModal({
  open,
  anchorEl,
  handleClose,
  shareLink,
  resourceID = '',
  resourceType = 'spark',
  resourceAccessLinkToken,
  privacyTypeId,
}: CreateFavouriteListPopUpProps) {
  const accessToken =
    privacyTypeId === 2 ? `?access_token=${resourceAccessLinkToken}` : '';
  const shareURL =
    shareLink ||
    `https://uat-sparkup-frontend.azurewebsites.net/${resourceType}/${resourceID}${accessToken}`;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClick={(e) => e.stopPropagation()}
      onClose={(e) => {
        //@ts-ignore
        e.stopPropagation();
        handleClose();
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '8px',
          padding: 2,
          margin: 2,
          marginTop: '28px',
        },
      }}
    >
      <Box display='flex' gap={4} flexDirection='column'>
        <Typography
          variant='h5'
          sx={{
            fontFamily: 'Mont-SemiBold',
            marginLeft: '10px',
          }}
        >
          Share
        </Typography>
        <Box
          display='flex'
          width='100%'
          gap={2}
          justifyContent='space-between'
          mb={-1}
        >
          <FacebookShareButton url={shareURL} windowWidth={800}>
            <FacebookIcon size={64} round />
          </FacebookShareButton>
          <TwitterShareButton url={shareURL} windowWidth={800}>
            <XIcon size={64} round />
          </TwitterShareButton>
          <WhatsappShareButton url={shareURL} windowWidth={800}>
            <WhatsappIcon size={64} round />
          </WhatsappShareButton>
          <LinkedinShareButton url={shareURL} windowWidth={800}>
            <LinkedinIcon size={64} round />
          </LinkedinShareButton>
        </Box>
        <Typography
          sx={{
            fontFamily: 'Mont-SemiBold',
            marginLeft: '10px',
            fontSize: '15px',
          }}
        >
          or copy link
        </Typography>
        <TextField
          name='listName'
          fullWidth
          value={shareURL}
          placeholder='example.com/share-link'
          InputProps={{
            endAdornment: (
              <SparkButton
                variant='contained'
                onClick={() => copyToClipboard(shareURL)}
              >
                Copy
              </SparkButton>
            ),
            readOnly: true,
          }}
          sx={{ mt: -1 }}
        />
      </Box>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          zIndex: 100,
          right: 8,
          top: 8,
          color: (theme) => theme.palette.common.black,
        }}
      >
        <CloseIcon />
      </IconButton>
    </Popover>
  );
}

export default SparkShareModal;
